export default __webpack_public_path__ + "static/media/clicky.b15c5498.jpg";